import AntdSkeleton from 'antd/lib/skeleton';
import React        from 'react';

export type SkeletonProps = React.ComponentProps<typeof AntdSkeleton>;
export type SkeletonAvatarProps = React.ComponentProps<typeof AntdSkeleton['Avatar']>;
export type SkeletonButtonProps = React.ComponentProps<typeof AntdSkeleton['Button']>;
export type SkeletonImageProps = React.ComponentProps<typeof AntdSkeleton['Image']>;
export type SkeletonInputProps = React.ComponentProps<typeof AntdSkeleton['Input']>;

const Skeleton = (props: SkeletonProps) => (
	<AntdSkeleton {...props} />
);

Skeleton.Avatar = (props: SkeletonAvatarProps) => (
	<AntdSkeleton.Avatar {...props} />
);

Skeleton.Button = (props: SkeletonButtonProps) => (
	<AntdSkeleton.Button {...props} />
);

Skeleton.Image = (props: SkeletonImageProps) => (
	<AntdSkeleton.Image {...props} />
);

Skeleton.Input = (props: SkeletonInputProps) => (
	<AntdSkeleton.Input {...props} />
);

export default Skeleton;